import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SettingsService} from './settings.service';
import {StorageService} from './storage.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {FirstStep} from 'app/original-models/firstStep.model';

@Injectable({ providedIn: 'root' })
export class FirstStepService {
    apiUrl: string;

    constructor(
        public http: HttpClient,
        private storageService: StorageService,
        private settings: SettingsService
    ) {
        this.apiUrl = this.settings.apiUrl;
    }

    getSteps(): Observable<any> {
        return this.http.get(`${this.apiUrl}/ftue/`).pipe(
            map((res) => {
                let data = new FirstStep().setFromApiModel(res);
                this.storageService.setStorageItem('progress', data.progress);
                return data;
            })
        );
    }

    updateStep(index?: number, value?: boolean): Observable<any> {
        let data = new FirstStep().getNameByIndex(index, value);
        return this.http.patch(`${this.apiUrl}/ftue/`, data).pipe(
            map((res) => {
                return new FirstStep().setFromApiModel(res);
            })
        );
    }
}
